'use strict';

var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Tabs = require('../../Tabs/Tabs.js');
var withStyles = require('../../../Styles/withStyles.js');
var classNames = require('classnames');
var AppBarTab = require('./AppBarTab.js');
var NavDash = require('../../../../IconsAndImages/Icons/NavDash.js');
var NavHQ = require('../../../../IconsAndImages/Icons/NavHQ.js');
var NavSchedule = require('../../../../IconsAndImages/Icons/NavSchedule.js');
var NavJobs = require('../../../../IconsAndImages/Icons/NavJobs.js');
var NavCustomers = require('../../../../IconsAndImages/Icons/NavCustomers.js');
var NavMap = require('../../../../IconsAndImages/Icons/NavMap.js');
var NavMyMoney = require('../../../../IconsAndImages/Icons/NavMyMoney.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    indicator: {
      backgroundColor: theme.palette.brandPrimary.main
    }
  };
};

var AppBarTabs = function AppBarTabs(_ref) {
  var classes = _ref.classes,
      showDash = _ref.showDash,
      showHQDash = _ref.showHQDash,
      showSchedule = _ref.showSchedule,
      showJobs = _ref.showJobs,
      showCustomers = _ref.showCustomers,
      showMap = _ref.showMap,
      showMyMoney = _ref.showMyMoney;
      objectWithoutProperties(_ref, ["classes", "showDash", "showHQDash", "showSchedule", "showJobs", "showCustomers", "showMap", "showMyMoney"]);

  return React__default["default"].createElement(Tabs, {
    value: 0,
    onChange: '',
    variant: "standard",
    indicatorColor: "primary",
    textColor: "inherit",
    classes: {
      indicator: classNames__default["default"](classes.indicator)
    }
  }, showDash && React__default["default"].createElement(AppBarTab, {
    label: "Dash",
    icon: React__default["default"].createElement(NavDash, null)
  }), showHQDash && React__default["default"].createElement(AppBarTab, {
    label: "Dash",
    icon: React__default["default"].createElement(NavHQ, null)
  }), showSchedule && React__default["default"].createElement(AppBarTab, {
    label: "Schedule",
    icon: React__default["default"].createElement(NavSchedule, null)
  }), showJobs && React__default["default"].createElement(AppBarTab, {
    label: "Jobs",
    icon: React__default["default"].createElement(NavJobs, null)
  }), showCustomers && React__default["default"].createElement(AppBarTab, {
    label: "Customers",
    icon: React__default["default"].createElement(NavCustomers, null)
  }), showMap && React__default["default"].createElement(AppBarTab, {
    label: "Map",
    icon: React__default["default"].createElement(NavMap, null)
  }), showMyMoney && React__default["default"].createElement(AppBarTab, {
    label: "My Money",
    icon: React__default["default"].createElement(NavMyMoney, null)
  }));
};

var AppBarTabs$1 = withStyles["default"](styles)(AppBarTabs);

module.exports = AppBarTabs$1;
